module.exports = __webpack_public_path__ + "static/img/日出东方控制器小程序设备详情.195b6e04.png";